import React from "react";

export default () =>
    <div>
        <h3>Min profil</h3>
        <p>Under utvikling - kommer senere.</p>
    </div>;